import { createContext } from "react";
import { Any } from "../../test-helpers/Any";
import {
    Credentials,
    ExternalLoginRequest,
    LoginMfaRequest,
    LoginRequest,
    LoginProvider,
    LoginResponse,
    MfaCodeRequest,
} from "../../models";

export interface IOidcContext {
    loginFail: () => Promise<void>;
    loginMFA: (loginMFARequest: LoginMfaRequest) => Promise<LoginResponse>;
    loginMFANewCode: (mfaCodeRequest: MfaCodeRequest) => Promise<void>;
    loginMFARequest: (loginRequest: LoginRequest) => Promise<void>;
    loginWithPassword: (credentials: Credentials) => Promise<void>;
    loginWithExternalProvider: (externalLoginRequest: ExternalLoginRequest) => Promise<void>;
    logout: () => Promise<void>;
    refresh: () => Promise<void>;
    getLoginProviders: () => Promise<LoginProvider[] | void>;
}

const defaultValue: IOidcContext = {
    loginFail: Any.voidPromise,
    loginMFA: () => Promise.resolve(Any.loginResponse()),
    loginMFANewCode: Any.voidPromise,
    loginMFARequest: Any.voidPromise,
    loginWithPassword: Any.voidPromise,
    loginWithExternalProvider: Any.voidPromise,
    logout: Any.voidPromise,
    refresh: Any.voidPromise,
    getLoginProviders: Any.voidPromise,
};

export const OidcContext = createContext<IOidcContext>(defaultValue);
OidcContext.displayName = "Oidc";
